import styled from 'styled-components';
import { TableCell } from '@material-ui/core';

export const StyledTableCell = styled(TableCell)<{ $paddingLeft: boolean }>`
    padding: ${({ theme, $paddingLeft }) =>
        $paddingLeft ? theme.spacing(1, 1) : theme.spacing(1, 0)};
    font-size: 12px;
`;
